module.exports = __webpack_public_path__ + "img/user.47e0b063.png";